<template>
  <div class="w-100">
    Invoice PAID for

    <span class="mr-1">
      <invoice-object
        :entity-id="invoiceId()"
        :invoice="$lodash.get(activity, 'detail.invoice')"
        :open-new="true"
      />
    </span>

    <b>{{ invoiceTotal() }}</b>
    collected using {{ invoicePaymentMethod() }}

    <pdf-object :href="invoicePdf()" />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
